import { render, staticRenderFns } from "./MatchMax.vue?vue&type=template&id=1227839c&scoped=true&"
import script from "./MatchMax.vue?vue&type=script&lang=js&"
export * from "./MatchMax.vue?vue&type=script&lang=js&"
import style0 from "./MatchMax.vue?vue&type=style&index=0&id=1227839c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1227839c",
  null
  
)

export default component.exports